import { MaterialDto } from "@dashboard/modules/material-management/material/model/material.dto";
import { CurrentAccountDto } from "@dashboard/modules/finance-management/current-account/model/current-account.dto";
import { CustomerDto } from "@dashboard/modules/shipping-management/customer/model/customer.dto";
import { BaseDto } from "@app/modules/shared/model/base.dto";

export class VirtualOrderDto extends BaseDto {
  public document_type?: string;
  public type?: string;
  public current_account?: CurrentAccountDto;
  public customer?: CustomerDto;
  public document_date?: any;
  public document_num?: string;
  public external_document_num?: string;
  public virtual_order_lines?: Array<VirtualOrderLinesDto>;
}

export class VirtualOrderLinesDto {
  id?: number;
  external_id: string;
  rec_status?: string;
  product_group: string;
  package_type: string;
  material?: MaterialDto;
  quantity: number;
  user_count: number;
}
